import { ChipSelect, ChipSelectInline } from "./ChipSelect";
import { Home, Building2, Castle, Warehouse } from "lucide-react";

const PROPERTY_ERA_OPTIONS = [
  { value: "classic", label: "Classic" },
  { value: "newbuild", label: "New Build" },
];

const PROPERTY_TYPE_OPTIONS = [
  { value: "detached", label: "Detached", icon: Home },
  { value: "semi-detached", label: "Semi-Detached", icon: Home },
  { value: "terrace", label: "Terraced", icon: Building2 },
  { value: "bungalow", label: "Bungalow", icon: Castle },
  { value: "flat", label: "Flat", icon: Warehouse },
];

const BEDROOM_OPTIONS = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3" },
  { value: "4_plus", label: "4+" },
];

const BATHROOM_OPTIONS = [
  { value: "1", label: "1" },
  { value: "2", label: "2" },
  { value: "3", label: "3+" },
];

const EPC_OPTIONS = [
  { value: "A_B", label: "A-B" },
  { value: "C", label: "C" },
  { value: "D_E", label: "D-E" },
  { value: "F_G", label: "F-G" },
  { value: "unknown", label: "?" },
];

export function PropertyBasicsScreen({ data, onChange }) {
  const updateField = (field, value) => {
    onChange({ ...data, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Property Era */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Property Era
        </label>
        <ChipSelect
          options={PROPERTY_ERA_OPTIONS}
          value={data.property_era}
          onChange={(v) => updateField("property_era", v)}
          columns={2}
        />
      </div>

      {/* Property Type */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          Property Type
        </label>
        <ChipSelect
          options={PROPERTY_TYPE_OPTIONS}
          value={data.dwelling_type}
          onChange={(v) => updateField("dwelling_type", v)}
          columns={2}
        />
      </div>

      {/* Bedrooms & Bathrooms Row */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
            Bedrooms
          </label>
          <ChipSelectInline
            options={BEDROOM_OPTIONS}
            value={data.bedrooms}
            onChange={(v) => updateField("bedrooms", v)}
          />
        </div>
        <div>
          <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
            Bathrooms
          </label>
          <ChipSelectInline
            options={BATHROOM_OPTIONS}
            value={data.bathrooms}
            onChange={(v) => updateField("bathrooms", v)}
          />
        </div>
      </div>

      {/* EPC Rating */}
      <div>
        <label className="text-xs font-semibold text-white/50 uppercase tracking-wider mb-3 block">
          EPC Rating
        </label>
        <ChipSelectInline
          options={EPC_OPTIONS}
          value={data.epc_band}
          onChange={(v) => updateField("epc_band", v)}
        />
      </div>
    </div>
  );
}

export function isPropertyBasicsComplete(data) {
  return (
    data.property_era &&
    data.dwelling_type &&
    data.bedrooms &&
    data.bathrooms &&
    data.epc_band
  );
}
